import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const resetPasswordActions = apiPromiseTypes('reset-password', 'post');
